// Gomera oracle-card draw - standalone per-route bundle, no Stimulus.
//
// Built as its own IIFE entry point (see package.json) and loaded only on
// /wahrsagekarten-valle-gran-rey via `javascript_include_tag "gomera_oracle"`,
// so the ported mini-apps never bloat the global bundle or touch the Stimulus
// registry (avoids the cross-bundle Stimulus breakage from 2026-06-08).
//
// Turbo-safe: a per-element guard makes init idempotent, and the turbo:load
// listener is registered once at window scope so repeat visits don't stack
// listeners.
(function () {
  var SHUFFLE_MS = 800;
  var FLIP_DELAY_MS = 200;
  var FLIP_MS = 600;

  function init() {
    var root = document.querySelector("[data-gomera-oracle]");
    if (!root || root.dataset.gomeraOracleBooted) return;

    var cards;
    try {
      cards = JSON.parse(root.dataset.cards || "[]");
    } catch (e) {
      return;
    }
    if (!cards.length) return;

    var card = root.querySelector("[data-gomera-oracle-card]");
    var cardFront = root.querySelector("[data-gomera-oracle-card-front]");
    var drawButton = root.querySelector("[data-gomera-oracle-draw]");
    var resetButton = root.querySelector("[data-gomera-oracle-reset]");
    var result = root.querySelector("[data-gomera-oracle-result]");
    var nameEl = root.querySelector("[data-gomera-oracle-name]");
    var introEl = root.querySelector("[data-gomera-oracle-intro]");
    var keywordsEl = root.querySelector("[data-gomera-oracle-keywords]");
    var loveEl = root.querySelector("[data-gomera-oracle-love]");
    var healthEl = root.querySelector("[data-gomera-oracle-health]");
    var careerEl = root.querySelector("[data-gomera-oracle-career]");
    var announceEl = root.querySelector("[data-gomera-oracle-announce]");
    if (!card || !cardFront || !drawButton) return;

    root.dataset.gomeraOracleBooted = "1";

    var flipped = false;
    var lastIndex = -1;
    var currentCard = null;

    // Pick a random card, avoiding an immediate repeat so "neu mischen" feels fresh.
    function randomCard() {
      if (cards.length === 1) return cards[0];
      var i = lastIndex;
      while (i === lastIndex) {
        i = Math.floor(Math.random() * cards.length);
      }
      lastIndex = i;
      return cards[i];
    }

    function draw() {
      if (flipped) return;

      drawButton.disabled = true;
      drawButton.classList.add("opacity-50", "cursor-not-allowed");
      card.classList.add("shuffling");

      setTimeout(function () {
        card.classList.remove("shuffling");
        currentCard = randomCard();
        cardFront.style.backgroundImage = "url('" + currentCard.image + "')";
        if (nameEl) nameEl.textContent = currentCard.name;
        if (introEl) introEl.textContent = currentCard.intro;
        if (keywordsEl) keywordsEl.textContent = currentCard.keywords;
        if (loveEl) loveEl.textContent = currentCard.love;
        if (healthEl) healthEl.textContent = currentCard.health;
        if (careerEl) careerEl.textContent = currentCard.career;

        setTimeout(function () {
          flip();
        }, FLIP_DELAY_MS);
      }, SHUFFLE_MS);
    }

    function flip() {
      card.classList.add("flipped");
      flipped = true;

      setTimeout(function () {
        if (result) {
          result.classList.remove("hidden");
          result.classList.add("fade-in");
        }
        // Announce the drawn card once, after the reveal, from the persistent
        // sr-only node - the visual result flips from display:none and isn't a
        // reliable live region on its own.
        if (announceEl && currentCard) {
          announceEl.textContent =
            currentCard.name + ". " + currentCard.intro + " " +
            "Bedeutung: " + currentCard.keywords + ". " +
            "Liebe: " + currentCard.love + " " +
            "Gesundheit: " + currentCard.health + " " +
            "Beruf: " + currentCard.career;
        }
        if (resetButton) resetButton.classList.remove("hidden");
      }, FLIP_MS);
    }

    function reset() {
      if (result) {
        result.classList.add("hidden");
        result.classList.remove("fade-in");
      }
      // Clear the announcement so redrawing the same card re-triggers it
      // (writing an identical textContent value wouldn't fire the live region).
      if (announceEl) announceEl.textContent = "";
      currentCard = null;
      if (resetButton) resetButton.classList.add("hidden");
      card.classList.remove("flipped");

      setTimeout(function () {
        flipped = false;
        drawButton.disabled = false;
        drawButton.classList.remove("opacity-50", "cursor-not-allowed");
      }, FLIP_MS);
    }

    drawButton.addEventListener("click", draw);
    // The card itself is a draw affordance too (it carries cursor:pointer);
    // draw() no-ops once flipped, so clicking the revealed face is harmless.
    card.addEventListener("click", draw);
    if (resetButton) resetButton.addEventListener("click", reset);
  }

  if (!window.__gomeraOracleBooted) {
    window.__gomeraOracleBooted = true;
    document.addEventListener("turbo:load", init);
  }

  init();
})();
